export const SET_SELECTED_ADDRESS = 'SET_SELECTED_ADDRESS';
export const SET_PICKUP_DATE = 'SET_PICKUP_DATE';
export const SET_PICKUP_TIME = 'SET_PICKUP_TIME';
export const SET_DELIVERY_SCHEDULE_TYPE = 'SET_DELIVERY_SCHEDULE_TYPE';
export const DELIVERY_INSTRUCTION = 'DELIVERY_INSTRUCTION';
export const SET_DELIVERY_NOTE = 'SET_DELIVERY_NOTE';
export const CLEAR_CHECKOUT_ADDRESS = 'CLEAR_CHECKOUT_ADDRESS';
export const RESET_SCHEDULE_DELIVERY='RESET_SCHEDULE_DELIVERY';

export const SET_ADDRESS_MODAL='SET_ADDRESS_MODAL'

export const deliveryScheduleAsapArr = ['1', '2'] // 1 for asap and second fo schedule

export const resetScheduleDeivery=()=>{
    return {
        type:RESET_SCHEDULE_DELIVERY,
        payload:'',
    }
}

export const setAddressModal =(data:any)=>{
    return {
        type: SET_ADDRESS_MODAL,
        payload:data
    }
}

export const CLEARCHECKOUTADDRESS = () => {
    return {
        type: CLEAR_CHECKOUT_ADDRESS,
        payload:''
    }
}


export const setDeliveryNote = (data: any) => {
    return {
        type: SET_DELIVERY_NOTE,
        payload: data
    }
}

export const setDeliveryInstruction = (data: any) => {
    return {
        type: DELIVERY_INSTRUCTION,
        payload: data
    }
}

export const setDeliveryScheduleType = (data: any) => {
    return {
        type: SET_DELIVERY_SCHEDULE_TYPE,
        payload: data
    }
}

export const setSelectedAddress = (data: any) => {
    return {
        type: SET_SELECTED_ADDRESS,
        payload: data
    }
}

export const setSelectedPickupDate = (data: any) => {
    return {
        type: SET_PICKUP_DATE,
        payload: data
    }
}
export const setSelectedPickupTime = (data: any) => {
    return {
        type: SET_PICKUP_TIME,
        payload: data
    }
}
const initialState: any = {
    selectedAddress: {},
    selectedPickupDate: '',
    selectedPickupTime: '',
    deliveryScheduleType: deliveryScheduleAsapArr[0],
    deliveryInstruction: '',
    deliveryNotes: '',
    addressModal:false,

}

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case SET_SELECTED_ADDRESS:
            return {
                ...state,
                selectedAddress: payload
            }
        case SET_PICKUP_DATE:
            return {
                ...state,
                selectedPickupDate: payload
            }
        case SET_PICKUP_TIME:
            return {
                ...state,
                selectedPickupTime: payload
            }
        case SET_DELIVERY_SCHEDULE_TYPE:
            return {
                ...state,
                deliveryScheduleType: payload

            }
        case DELIVERY_INSTRUCTION:
            return {
                ...state,
                deliveryInstruction: payload
            }
        case SET_DELIVERY_NOTE:
            return {
                ...state,
                deliveryNotes: payload
            }
        case SET_ADDRESS_MODAL:
            return {
                ...state,
                addressModal:payload,
            }
        case RESET_SCHEDULE_DELIVERY:
            return {
                ...state,
                deliveryScheduleType:deliveryScheduleAsapArr[0],
                selectedPickupTime:'',
                selectedPickupDate:'',

            }
        case CLEAR_CHECKOUT_ADDRESS:
            return initialState;
        default:
            return state
    }
}

export default reducer;